import React from 'react';
import { createRoot } from 'react-dom/client';
import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import ReactGA from 'react-ga4';

import firebaseConfig from './config/firebaseConfig';
import AppV2 from './AppV2';

// In-browser shim for `process` used by some libs (prevents `process is not defined`)
declare const window: any;
if (typeof (window as any).process === 'undefined') {
  (window as any).process = { env: {} };
}

const TRACKING_ID = 'G-P48R7L5DV1'; // OUR_TRACKING_ID
ReactGA.initialize(TRACKING_ID);

firebase.initializeApp(firebaseConfig);

const rootElement = document.getElementById('root');
if (rootElement) {
  const root = createRoot(rootElement);
  root.render(<AppV2 />);
}
